import React from 'react';
import { LwShell } from '../../components/lw/LwShell';
import { GreenHeader } from '../../components/lw/GreenHeader';
import { Btn } from '../../components/lw/Btn';
import { FormControl } from '../../components/lw/FormControl';
import { Logo } from '../../components/lw/Logo';

// Reviewable showcase of the ported LeaseWise design foundation.
export function LwStyleGuide() {
  return (
    <LwShell>
      <GreenHeader title="Style Guide" subtitle="Ported design foundation" />
      <div className="main-content">
        <div className="form-group">
          <Btn variant="primary">Primary Button</Btn>
        </div>
        <div className="form-group">
          <Btn variant="secondary">Secondary Button</Btn>
        </div>
        <FormControl id="sample-input" label="Sample field" placeholder="Type here" />
        <Logo style={{ width: 120, height: 120 }} />
      </div>
    </LwShell>
  );
}

export default LwStyleGuide;
